export default __webpack_public_path__ + "static/media/beylikduzuImg.7f6790c3.jpg";